import styles from './PulsingDots.module.css';

export interface PulsingDotsProps {
  className?: string;
  label?: string;
}

export function PulsingDots({ className, label = 'Loading' }: PulsingDotsProps) {
  return (
    <span
      className={`${styles.container}${className ? ` ${className}` : ''}`}
      role="status"
      aria-label={label}
    >
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.dot} aria-hidden="true" />
    </span>
  );
}
